import React, { createContext, FunctionComponent, useContext } from 'react';

const ReferrerAllowlistContext = createContext<string[] | undefined>(undefined);

interface ReferrerAllowlistProviderProps {
  referrerAllowlist?: string[];
}

export const ReferrerAllowlistProvider: FunctionComponent<
  ReferrerAllowlistProviderProps
> = ({ referrerAllowlist, children }) => (
  <ReferrerAllowlistContext.Provider value={referrerAllowlist}>
    {children}
  </ReferrerAllowlistContext.Provider>
);

export const useReferrerAllowlist = () => useContext(ReferrerAllowlistContext);
